import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <Loader2 size={40} className="animate-spin text-goldsoft" />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
